import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import { TemplateHeaderPreview } from '../main/options/model/types'

interface tabSelected {
    name: string
    indexOf: number    
}
function SelectExactTab({
    template,
    tabSelected,
    setTab
}: {
    template: TemplateHeaderPreview
    tabSelected: tabSelected
    setTab: (tab: tabSelected) => void
}) {
    const sheetData = template?.sheetData || []
    const [draftTab, setDraftTab] = useState<tabSelected>(defaultTabSelected)

    const getTabName = () => {
        if (!draftTab) return '--'
        if (draftTab?.name.length > 0) return draftTab.name
        return draftTab?.indexOf >= 0 ? draftTab?.indexOf : '...'
    }

    useEffect(() => {
        if (tabSelected.indexOf != draftTab.indexOf) {
            setDraftTab(tabSelected)
        }
    }, [tabSelected])

    useEffect(() => {
        if (!template) setDraftTab(defaultTabSelected)
        else setDraftTab(tabSelected)
        
    }, [template])

    return (
        <SelectSheetContent>
            <div
                style={{
                    padding: '4px',
                    display: !!getTabName() ? 'block' : 'none'
                }}
            >
                <span>Reference Tab: </span>
                <label style={{height:'16px'}}>
                    {getTabName()}{' '}
                    <i
                        className="far fa-edit fa-fw"
                        style={{
                            fontSize: '14px',
                            cursor: 'pointer',
                            padding: '10px',
                            display: tabSelected.indexOf !== -1 ? 'inline-block' : 'none'
                        }}
                        onClick={() => setTab(defaultTabSelected)}
                    />
                </label>
            </div>
            <div
                style={{
                    width: '100%',
                    padding: '5px',
                    display: tabSelected.indexOf === -1 ? 'inline-block' : 'none'
                }}
            >
                <div
                    style={{
                        height: 200,
                        overflowY: 'auto',                        
                    }}
                >
                    {sheetData.map((tab, index) => {
                        const selected = draftTab.indexOf == index
                        return (
                            <div key={`tab-${template?.uid}-${index}`} className='tab-selector'>
                               <Radio
                                    checked={selected}
                                    type={'radio'}
                                    key={`tab-radio-${template?.uid}-${index}`}
                                    onClick={() => {
                                        if (selected) setDraftTab(defaultTabSelected)
                                        setDraftTab({ indexOf: index, name: tab.sheetName })
                                    }} className='tab-selector-check'
                                />
                                <span className='tab-selector-text'
                                    style={{
                                        display: 'inline',
                                        padding: '7px',
                                        fontWeight: selected ? 'bold' : 'normal'
                                    }}
                                >
                                    {tab.sheetName}
                                </span>
                            </div>
                        )
                    })}
                </div>
                <button
                    style={{
                        padding: '5px',
                        marginTop: '10px'
                    }}
                    disabled={draftTab.indexOf == -1}
                    onClick={() => setTab(draftTab)}
                    className="btn btn-primary"
                >
                    Select tab
                </button>
            </div>
        </SelectSheetContent>
    )
}

const SelectSheetContent = styled.div`
    width: 100%;
    overflow-y: auto;
    padding: 4px;  
    
    .tab-selector{
        display:flex;
        align-items: center;
    }

`
const Radio = styled.input`
    background: #ffffff;    
    border-radius: 70px;
`
export const defaultTabSelected = {
    indexOf: -1,
    name: '',
    fileName:''
} as tabSelected

export { SelectExactTab, tabSelected }
